class imagesCarousel {
  constructor (items, id, maxItems) {
    let self = this
    this.items = items
    this.id = id
    this.maxItems = maxItems
    this.initialized = false
    this.carouselContainer = document.getElementById(id)
    this.carousel = this.carouselContainer.querySelector('.swiper-container')
    this.carouselWrapper = this.carousel.querySelector('.swiper-wrapper')
    this.createSlides()
    this.createCarousel()
    this.swiper = this.carousel.swiper;

    this.carouselContainer.querySelector('.close').addEventListener('click', (e) => {
      self.carouselContainer.classList.remove('open')
    })

    console.log('Modal images', this)

    this.carouselContainer.addEventListener('click', (e) => {
      if (e.target === this.carouselContainer) {
        self.carouselContainer.classList.remove('open')
      }
    })
  }

  createSlides() {
    for (let i = 0; i < this.maxItems; i++) {
      let item = this.items[i]
      this.createSlide(item)
    }
  }

  createSlide(itemData) {
    let imgUrl = itemData.filename

    let slide = document.createElement('div')
    slide.classList.add('swiper-slide')

    let modalImageWrapper = document.createElement('div')
    modalImageWrapper.classList.add('modal-image-picture-wrapper')

    let image = document.createElement('img')
    image.classList.add('modal-image-picture')
    image.setAttribute('data-src', '../assets/images/photos/' + imgUrl)
    image.classList.add('swiper-lazy')
    modalImageWrapper.appendChild(image)

    let name = document.createElement('div')
    name.classList.add('modal-image-worker-name')
    name.innerHTML = itemData.name

    let place = document.createElement('div')
    place.classList.add('modal-image-worker-place')
    place.innerHTML = itemData.place

    let job = document.createElement('div')
    job.classList.add('modal-image-worker-job')
    job.innerHTML = itemData.jobTitle

    // Preloader.
    let lazy_preloader = document.createElement('div')
    lazy_preloader.classList.add('swiper-lazy-preloader')
    slide.appendChild(lazy_preloader)

    slide.appendChild(modalImageWrapper)
    slide.appendChild(name)
    slide.appendChild(place)
    slide.appendChild(job)

    this.carouselWrapper.appendChild(slide)
  }

  createCarousel() {
    let self = this
    new Swiper(this.carousel, {
      loop: false,
      speed: 500,
      threshold: 20,
      lazy: true,
      // If we need pagination
      pagination: {
        el: self.carouselContainer.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: self.carouselContainer.querySelector('.swiper-button-next'),
        prevEl: self.carouselContainer.querySelector('.swiper-button-prev'),
      },
      on: {
        init: function () {
          self.initialized = true
        },
        slideChangeTransitionStart: function () {
          if (self.initialized === true) {
          }
        },
      }
    })
  }
}